import type { Meta, StoryFn } from '@storybook/react';
import type { BackdropProps } from './Backdrop';

import { Backdrop } from './Backdrop';

import { Container } from 'storyComponents/Container';

import './Backdrop.stories.css';

type BackdropStoryProps = BackdropProps & { visible: boolean };

const codeString = '<Backdrop>{children}</Backdrop>';

// eslint-disable-next-line import/no-default-export
export default {
  title: 'Atoms/Backdrop',
  component: Backdrop,
  argTypes: {
    children: {
      control: 'text',
    },
    visible: {
      control: 'boolean',
      name: 'Show Backdrop',
    },
  },
  parameters: {
    inspectComponent: Backdrop,
    codeString: codeString,
  },
} as Meta<BackdropStoryProps>;

const Template: StoryFn<BackdropStoryProps> = (args) => {
  return (
    <Container visible={args.visible}>
      <Backdrop>
        <div className="container">{args.children}</div>
      </Backdrop>
    </Container>
  );
};

export const BackdropExample = Template.bind({});
BackdropExample.args = {
  visible: true,
  children: 'Dummy Overlay',
};
